module.exports = __webpack_public_path__ + "img/logotype-uniti.f6e05526.png";